import { z } from 'zod';

import { ShotLoad } from '../../statistics/shot-load';

export type WeeklyReportUiState = z.output<typeof weeklyReportUiStateSchema>;
export type WeeklyReportUiStateDTO = z.input<typeof weeklyReportUiStateSchema>;

export const weeklyReportUiStateSchema = z.object({
  performanceStats: z
    .object({
      expanded: z.boolean().catch(true),
    })
    .catch({
      expanded: true,
    }),
  shotAreas: z
    .object({
      expanded: z.boolean().catch(true),
      selectedAreaMap: z.enum(['fgp', 'distr', 'xvalue']).catch('fgp'),
    })
    .catch({
      expanded: true,
      selectedAreaMap: 'fgp',
    }),
  shotLoad: z
    .object({
      expanded: z.boolean().catch(true),
      selectedAreaMap: z.enum(['fgp', 'distr', 'xvalue']).catch('fgp'),
      selectedShotLoad: z.enum(ShotLoad).catch(ShotLoad.HIGH),
    })
    .catch({
      expanded: true,
      selectedAreaMap: 'fgp',
      selectedShotLoad: ShotLoad.HIGH,
    }),
  shotStats: z
    .object({
      expanded: z.boolean().catch(true),
    })
    .catch({
      expanded: true,
    }),
});
